"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeByKey = exports.rgbToHex = exports.componentToHex = exports.colorToHex = exports.getSwatchesForTheme = exports.fixColor = exports.hexToRgb = void 0;
const React = __importStar(require("react"));
const themes = __importStar(require("../themes"));
const errors_1 = require("../errors/errors");
const styled_components_1 = __importDefault(require("styled-components"));
function hexToRgb(hex = "") {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
    });
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        }
        : { r: 0, g: 0, b: 0 };
}
exports.hexToRgb = hexToRgb;
function fixColor(args) {
    // tslint:disable-next-line: one-variable-per-declaration
    const hex = args.hex, elem = args.elem, rgb = hexToRgb(hex);
    const o = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000);
    let color = args.lightColor || "#F9F9F9";
    if (o > 125) {
        color = args.darkColor || "#333333";
    }
    if (args.text) {
        elem.css("color", color);
    }
    if (args.background) {
        elem.css("background-color", color);
    }
    return color;
}
exports.fixColor = fixColor;
exports.getSwatchesForTheme = (themeKey) => {
    const theme = themes[themeKey];
    const ColorSwatch = styled_components_1.default.div `
      background: ${p => p.color};
      color: ${p => fixColor({ hex: p.color, elem: "#ffffff" })};
      margin: 10px;
      box-shadow: rgba(20, 20, 20, 0.27) 1px 1px 20px;
      height: 140px;
      width: 140px;
      display: inline-grid;
      align-content: space-between;
      font-size: 16px;
      padding: 10px;
      vertical-align: middle;
      & img {
         max-width: 80px;
         max-height: 80px;
      }
   `;
    const Hex = styled_components_1.default.div `
      color: ${p => fixColor({ hex: p.color, elem: "#ffffff" })};
      font-size: 11px;
      text-align: right;
   `;
    const ImageWrapper = styled_components_1.default.div `
      text-align: center;
   `;
    const Image = (props) => {
        return (React.createElement("a", { href: props.url },
            React.createElement("img", { src: props.url })));
    };
    const swatches = Object.keys(theme).map((key) => {
        const value = theme[key];
        // URL
        if (value.indexOf("/") != -1) {
            // image
            if (value.match(/(jpg)|(png)|(ico)/)) {
                // we have to strip out the chunk hash added by webpack or else we'll mess up the snapshots
                const fileNameRegex = /.+\/(.+)\..+(\.\w{3})/;
                const matches = value.match(fileNameRegex) || ["", ""];
                const fileName = matches[1];
                const extension = matches[2];
                return (React.createElement(ColorSwatch, { key: key, color: "#000" },
                    key,
                    React.createElement(ImageWrapper, null,
                        React.createElement(Image, { url: value })),
                    React.createElement(Hex, { color: "#000" }, `${fileName}${extension}`)));
            }
        }
        else {
            // color
            if (value.indexOf("rgb") != -1 || value.indexOf("#") == 0) {
                return (React.createElement(ColorSwatch, { key: key, color: value },
                    key,
                    React.createElement(Hex, { color: value }, value)));
            }
        }
        //something else
        return (React.createElement(ColorSwatch, { key: key, color: "#fff" },
            key,
            React.createElement(Hex, { color: "#fff" }, value)));
    });
    return React.createElement("div", null, swatches);
};
function colorToHex(rgb) {
    rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    const hex = (x) => {
        return ("0" + parseInt(x, 10).toString(16)).slice(-2);
    };
    return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
}
exports.colorToHex = colorToHex;
function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
exports.componentToHex = componentToHex;
function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}
exports.rgbToHex = rgbToHex;
function getThemeByKey(key) {
    if (key === "servicepro") {
        return themes["sp10"];
    }
    else {
        const theme = themes[key];
        if (theme) {
            return theme;
        }
        else {
            errors_1.displayAndLogErrorWithMessage(new Error(`Could not load theme ${key}, defaulting to sp10`), "CouldNotLoadTheme");
            return themes["sp10"];
        }
    }
}
exports.getThemeByKey = getThemeByKey;
//# sourceMappingURL=themeUtils.js.map